export const isFieldVisible = (field, settings) => {
  if (!field.visibleWhen) return true

  return settings[field.visibleWhen.key] === field.visibleWhen.value
}

export const getVisibleFields = (fields, settings) => fields.filter(field => isFieldVisible(field, settings))
